export * from "./hotel-reserve-card-content";
